export const RIGHT = 'right';

const dimensionSides = [RIGHT];

export default dimensionSides;
